/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserAccount
 */
export interface UserAccount {
    /**
     * 
     * @type {string}
     * @memberof UserAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccount
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccount
     */
    'status': UserAccountStatusEnum;
}

export const UserAccountStatusEnum = {
    Active: 'active',
    Invited: 'invited',
    Unknown: 'unknown'
} as const;

export type UserAccountStatusEnum = typeof UserAccountStatusEnum[keyof typeof UserAccountStatusEnum];


